/**
 * The invite-less journey — mock assignments, fixed OTP `123456` — is a
 * development affordance. It is what the app's root serves when the URL carries
 * no invite token, which is why a bare visit to a deployed host used to land on
 * a sign-in screen advertising the demo code.
 *
 * Baked into the bundle at build time from the environment's own env file (see
 * Dockerfile), and off unless that file explicitly turns it on — so UAT and
 * PROD candidates can only ever enter through a real invite link.
 */
export const DEMO_MODE = process.env.NEXT_PUBLIC_DEMO_MODE === "true";
